const API_HOST = typeof import.meta.env.VITE_API_URL !== 'undefined' ? import.meta.env.VITE_API_URL : '';
const AUTHENTICATE_URL = `${API_HOST}${import.meta.env.VITE_API_AUTHENTICATE}`;
const CHANGE_LANGUAGE_URL = `${API_HOST}${import.meta.env.VITE_API_CHANGE_LANGUAGE}`;
const GET_PLAYER_HISTORY_URL = `${API_HOST}${import.meta.env.VITE_API_FETCH_PLAYER_HISTORY}`;
const GET_PLAYER_DAY_HISTORY_URL = `${API_HOST}${import.meta.env.VITE_API_FETCH_PLAYER_DAY_HISTORY}`;
const SET_FAVORITE_URL = `${API_HOST}${import.meta.env.VITE_API_SET_FAVORITE}`;
const OUTGOING_CALLS = `${API_HOST}${import.meta.env.VITE_API_OUTGOING_CALLS}`;
const AUTH_URL = `${API_HOST}${import.meta.env.VITE_API_AUTH}`;
const GET_USER_URL = `${API_HOST}${import.meta.env.VITE_API_GET_USER}`;
const CLEAR_AUTH_PARAMS = `${API_HOST}${import.meta.env.VITE_API_CLEAR_AUTH_PARAMS}`;

export {
  API_HOST,
  AUTH_URL,
  AUTHENTICATE_URL,
  CHANGE_LANGUAGE_URL,
  GET_PLAYER_HISTORY_URL,
  GET_PLAYER_DAY_HISTORY_URL,
  SET_FAVORITE_URL,
  GET_USER_URL,
  CLEAR_AUTH_PARAMS,
  OUTGOING_CALLS,
};
